import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CommunicationService } from '../../services/communication.service';
import { OrderProcessResponse, UpdateOrderProcess } from '../../jurisdiction-overview/jurisdiction-overview.domain';

@Injectable()
export class OrderProcessService {
  constructor(private communicationService: CommunicationService) {}

  getOrderProcessData(orderProcessId: string): Observable<OrderProcessResponse> {
    return this.communicationService.getData(`orderprocess?orderprocess_id=${orderProcessId}`);
  }

  getOrderProcessDataByApplicationId(applicationId: string): Observable<OrderProcessResponse> {
    return this.communicationService.getData(`orderprocess?application_id=${applicationId}`);
  }

  getAllOrderProcesses(): Observable<OrderProcessResponse> {
    return this.communicationService.getData('orderprocess');
  }

  updateOrderProcessData(orderProcessId: string, requestData: UpdateOrderProcess): Observable<OrderProcessResponse> {
    return this.communicationService.updateData(`orderprocess?orderprocess_id=${orderProcessId}`, requestData);
  }

  readDocument(documentId: string): Observable<Blob> {
    return this.communicationService.getData('orderprocess/document?document_id=' + documentId, { responseType: 'blob' });
  }

  uploadDocument(file: File, documentId: string, docIdType: string, docId: string): Observable<any> {
    const formData = new FormData();
    formData.append('document', file);

    if (documentId) {
      return this.communicationService.updateData(`orderprocess/document?document_id=${documentId}`, formData);
    }

    formData.append(docIdType, docId);
    formData.append('name', file.name);
    formData.append('sk_document_type', 'other');

    return this.communicationService.postData('orderprocess/document', formData);
  }

  uploadExampleDocument(file: File, docId: string, docIdType: string, documentType: string): Observable<any> {
    const formData = new FormData();

    formData.append('document', file);
    formData.append(docIdType, docId);
    formData.append('name', file.name);
    formData.append('sk_document_type', documentType);

    return this.communicationService.postData('orderprocess/document/example', formData);
  }
}
